"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setNewEvents = void 0;
function setNewEvents(_a) {
    var state = _a.state, zoneId = _a.zoneId, matchId = _a.matchId, bannerType = _a.bannerType;
    if (!zoneId) {
        return null;
    }
    var zoneBanners = state.get('zoneBanners');
    var banner = zoneBanners.get(zoneId);
    var newZoneBanners = zoneBanners;
    if (banner) {
        var newConfig = banner.config.map(function (item) {
            if (item.type === bannerType) {
                return __assign(__assign({}, item), { id: matchId || null });
            }
            return item;
        });
        newZoneBanners = zoneBanners.set(zoneId, banner.set('config', newConfig));
    }
    return newZoneBanners;
}
exports.setNewEvents = setNewEvents;
//# sourceMappingURL=utils.js.map